

import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import SendIcon from "@mui/icons-material/Send";
import StopIcon from "@mui/icons-material/Stop";
import { Snackbar } from "@mui/material";
import picLogo from "../../assets/images/user.png";
import languageLogo from "../../assets/images/lagauge_logo.svg";
import namaste from "../../assets/gif/namaste.gif";
import intro from "../../assets/audio/intro.wav";
import hindiwaiting from "../../assets/audio/hindiwaiting.wav";
import avatarBanner from "../../assets/images/Avatar banner.png";
import refreshButton from "../../assets/images/refreshbutton.svg";
import {
  CALL_AGENT_STREAM_URL,
  CHATBOT_URL, SPEECH_TO_TEXT_URL, TTS_URL, BHASHINI_API_KEY, BHASHINI_ENDPOINT_URL, GEOCODING_URL,
} from "../../utils/constants";
import micIcon from "../../assets/images/Mic.svg";
import ToggleSwitch from "../commonComponent/toggleSwitch";
import BotHeader from "../schemesBot/BotHeader";
import { useTranslation } from "react-i18next";
import { useCrypto } from "../../context/CryptoContext";
import { useSession } from "../../context/SessionContext";
import { KpmgTransliterate } from "../commonComponent/TranslitrationSuggestion/KpmgTransliterate";
import LanguageModal from "../commonComponent/LanguageModel/LanguageModal";
import SocketMicStreamer from "./SocketMicStreamerNewUi";
import ChatMessages from "./ChatMessages";
import "./index.css";
import styled from "styled-components";
import {
  ChatBotAvatarCTA,
  ChatbotHeader,
} from "../globalChatbot/ChatbotShellParts";
import closeIcon from "../../assets/pages/landing/close.svg";
import expandIcon from "../../assets/pages/landing/expand.svg";
import { WelcomeBanner, FAQSection } from "../ChatHomeComponents";

const apiKey = BHASHINI_API_KEY;
// IIT-H model — supports: en, hi, bn, gu, kn, ml, mr, or, pa, ta, te, ur, as, mni
const TLD_SERVICE_ID = "bhashini/iiiith/indic-lang-detection-all";
const ALD_SERVICE_ID = "bhashini/iitmandi/audio-lang-detection/gpu";
const CHATBOT_OVERLAY_Z_INDEX = 25000;

const MIC_BUTTON_STYLE = {
  width: "60px",
  height: "60px",
  borderRadius: "50%",
  border: "none",
  background: "#ffffff",
  boxShadow: "0 0 20px rgba(0, 135, 135, 0.28)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  padding: 0,
  cursor: "pointer",
};

const FAQ_ITEMS = [
  {
    question: "What are the authorized and paid-up share capitals of NMDFC?",
  },
  {
    question: "Who are the target groups for NMDFC assistance?",
  },
  { question: "I need a loan" },
  { question: "What activities does NMDFC engage in?" },
  {
    question:
      "What are the aims and objectives of the (NMDFC), and when was it established?",
  },
];

const PrayasBot = ({
  fontSize,
  onQuestionAsked,
  onResetNav,
  expanded,
  embeddedExpanded = false,
  onClose,
  onExpandMin,
  // ── Shared state from LandingPage (lifted up so widget & expanded share history)
  sharedChatbotInput,
  setSharedChatbotInput,
  sharedChatbotOutput,
  setSharedChatbotOutput,
  sharedChatTimestamps,
  setSharedChatTimestamps,
  sharedResponseTimestamps,
  setSharedResponseTimestamps,
}) => {
  const paragraphRef = useRef(null);
  const inputRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  // Use shared state when provided by parent (widget/expanded mode),
  // fall back to local state when used standalone (e.g. /chatbot route).
  const [localChatbotInput, setLocalChatbotInput] = useState([]);
  const [localChatbotOutput, setLocalChatbotOutput] = useState([]);
  const [localChatTimestamps, setLocalChatTimestamps] = useState([]);
  const [localResponseTimestamps, setLocalResponseTimestamps] = useState([]);

  const chatbotInput        = sharedChatbotInput        ?? localChatbotInput;
  const setChatbotInput     = setSharedChatbotInput     ?? setLocalChatbotInput;
  const chatbotOutput       = sharedChatbotOutput       ?? localChatbotOutput;
  const setChatbotOutput    = setSharedChatbotOutput    ?? setLocalChatbotOutput;
  const chatTimestamps      = sharedChatTimestamps      ?? localChatTimestamps;
  const setChatTimestamps   = setSharedChatTimestamps   ?? setLocalChatTimestamps;
  const responseTimestamps  = sharedResponseTimestamps  ?? localResponseTimestamps;
  const setResponseTimestamps = setSharedResponseTimestamps ?? setLocalResponseTimestamps;

  const normalizeLanguageCode = (languageCode = "") => {
    const value = String(languageCode || "").trim();
    if (!value) return "en";
    const normalized = value.toLowerCase().replace(/_/g, "-");
    return normalized.split("-")[0] || "en";
  };

  const [copyBar, setCopyBar] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const audioRef = useRef(null);
  const audioRef1 = useRef(null);
  const backgroundMusicRef = useRef();
  const waitingAudioRef = useRef();
  // Default to Hindi, while retaining a language explicitly selected from the
  // Bhashini plugin before the chatbot is opened.
  const [selectedLanguageCode, setSelectedLanguageCode] = useState(() => {
    const pluginLanguage =
      sessionStorage.getItem("bhashini_from_target_lang") ||
      sessionStorage.getItem("selectedLang") ||
      localStorage.getItem("preferredLanguage");

    return normalizeLanguageCode(pluginLanguage || "hi");
  });
  const [audioBase64, setAudioBase64] = useState("");
  const mediaRecorderRef = useRef(null);
  const [correctedInput, setCorrectedInput] = useState(null);
  const [suggestionsList, setSuggestionsList] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [questionLoading, setQuestionLoading] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(null);
  const [isSuggestionClicked, setIsSuggestionClicked] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const { t, i18n } = useTranslation();
  const [chatTimestampsLocal, setChatTimestampsLocal] = useState([]);  // unused alias kept for safety
  const [recordingTimer, setRecordingTimer] = useState(0);
  const [preventKeySearch, setPreventKeySearch] = useState(false);
  const timerIntervalRef = useRef(null);
  const [isSourceDataModelOpen, setIsSourceDataModelOpen] = useState(false);
  const downloadButtonRefs = useRef({});
  const [abortController, setAbortController] = useState(null);
  const [canStop, setCanStop] = useState(false);
  const micRef = useRef(null);
  const [manualInput, setManualInput] = useState(false);
  const [playingAudioIndex, setPlayingAudioIndex] = useState(null);
  const [isMicButtonClicked, setIsMicButtonClicked] = useState(false);
  const [isSpeechToTextLoading, setIsSpeechToTextLoading] = useState(false);
  const [detectedLanguage, setDetectedLanguage] = useState(null);
  const [isMicButtonDisabled, setMicButtonDisabled] = useState(false);
  const audioRefs = useRef({});
  const [showLanguages, setShowLanguages] = useState(false);
  const [showAudioButton, setShowAudioButton] = useState(true);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const hasMicBeenClickedRef = useRef(false);
  const [isTextBoxOpen, setIsTextBoxOpen] = useState(false);
  const [clearSuggestions, setClearSuggestions] = useState(false);
  const chatEndRef = useRef(null);
  const finalTextRef = useRef("");
  const interimTextRef = useRef("");
  const isListeningRef = useRef(false);
  const isProgrammaticUpdateRef = useRef(false);
  const [waitingAudio, setWaitingAudio] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const [isVoiceJourney, setIsVoiceJourney] = useState(false);
  // Track whether the current query originated from a mic recording
  const isVoiceInputRef = useRef(false);
  // Ref to hold latest audioRefs for auto-play after voice responses
  const latestResponseIndexRef = useRef(null);
  const { sessionId, generateNewSession } = useSession();
  const { aesKey } = useCrypto();
  const languageRef = useRef(null);

  const userName = "Demo User";

  let audioChunks = [];

  // ── Helpers ──────────────────────────────────────────────────────────────

  const generateTimestamp = () => {
    const now = new Date();
    const datePart = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(now);
    const timePart = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(now)
      .toUpperCase();
    return `${datePart} • ${timePart}`;
  };

  const clearInput = () => {
    finalTextRef.current = "";
    interimTextRef.current = "";
    setSearchText("");
  };

  async function getStateFromLatLng(lat, lng) {
    const res = await fetch(
      `${GEOCODING_URL}?format=json&lat=${lat}&lon=${lng}`,
    );
    const data = await res.json();
    return data.address.state;
  }

  /**
   * Detects the language of a typed text string using Bhashini's txt-lang-detection API.
   * Returns a 2-letter ISO language code (e.g. "hi", "en") or null on failure.
   * Skips detection for very short inputs (< 10 chars) where accuracy is poor.
   */
  const detectTextLanguage = async (text) => {
    if (!text || text.trim().length < 10) return null;
    try {
      const res = await fetch(BHASHINI_ENDPOINT_URL, {
        method: "POST",
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify({
          pipelineTasks: [{
            taskType: "txt-lang-detection",
            config: { serviceId: TLD_SERVICE_ID },
          }],
          inputData: {
            input: [{ source: text.trim() }],
          },
        }),
      });
      if (!res.ok) return null;
      const data = await res.json();
      const langCode = data?.pipelineResponse?.[0]?.output?.[0]?.langPrediction?.[0]?.langCode;
      console.log("[TLD] Detected language:", langCode, "for text:", text.substring(0, 30));
      return langCode || null;
    } catch (err) {
      console.warn("[TLD] Detection failed, falling back to selectedLanguageCode:", err.message);
      return null;
    }
  };

  // ── Effects ───────────────────────────────────────────────────────────────

  const syncSpokenLanguage = useCallback((code) => {
    if (typeof code !== "string" || !code.trim()) return null;
    const languageCode = code.trim().toLowerCase().replace(/_/g, "-").split("-")[0];
    if (!i18n.hasResourceBundle(languageCode, "translation")) return null;

    setSelectedLanguageCode(languageCode);
    setClearSuggestions((previous) => !previous);
    i18n.changeLanguage(languageCode);
    window.dispatchEvent(
      new CustomEvent("bhashini-language-select", { detail: { languageCode } }),
    );
    return languageCode;
  }, [i18n]);

  useEffect(() => {
    i18n.changeLanguage(selectedLanguageCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        Object.values(audioRefs.current).forEach((audio) => {
          if (audio && !audio.paused) {
            audio.pause();
            audio.currentTime = 0;
          }
        });
        if (backgroundMusicRef.current && !backgroundMusicRef.current.paused) {
          backgroundMusicRef.current.pause();
          backgroundMusicRef.current.currentTime = 0;
        }
        if (waitingAudioRef.current && !waitingAudioRef.current.paused) {
          waitingAudioRef.current.pause();
          waitingAudioRef.current.currentTime = 0;
        }
        setPlayingAudioIndex(null);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  useEffect(() => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) =>
        setUserLocation(await getStateFromLatLng(latitude, longitude)),
      (err) => console.warn("Location denied:", err.message),
    );
  }, []);

  useEffect(() => {
    if (!chatEndRef.current) return;
    if (searchText || isTextBoxOpen || isMicButtonClicked) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [searchText, isTextBoxOpen, isMicButtonClicked]);

  useEffect(() => {
    if (!detectedLanguage) return;
    const normalizedLanguage = normalizeLanguageCode(detectedLanguage);
    setSelectedLanguageCode(normalizedLanguage);
    i18n.changeLanguage(normalizedLanguage);
  }, [detectedLanguage, i18n]);

  useEffect(() => {
    const handleBhashiniLanguageSync = (event) => {
      const incomingLanguage =
        event?.detail?.languageCode ||
        event?.detail?.code ||
        event?.detail?.value ||
        event?.detail?.language;
      // Ignore incomplete events instead of changing the Hindi default to English.
      if (!incomingLanguage) return;
      const normalizedLanguage = normalizeLanguageCode(incomingLanguage);
      if (!normalizedLanguage) return;

      setSelectedLanguageCode(normalizedLanguage);
      localStorage.setItem("preferredLanguage", normalizedLanguage);
      sessionStorage.setItem("selectedLang", normalizedLanguage);
      i18n.changeLanguage(normalizedLanguage);
    };

    window.addEventListener("bhashini-language-change", handleBhashiniLanguageSync);
    window.addEventListener("bhashini-language-select", handleBhashiniLanguageSync);

    return () => {
      window.removeEventListener("bhashini-language-change", handleBhashiniLanguageSync);
      window.removeEventListener("bhashini-language-select", handleBhashiniLanguageSync);
    };
  }, [i18n]);

  useEffect(() => {
    const normalizedLanguage = normalizeLanguageCode(selectedLanguageCode || "hi");
    if (normalizedLanguage !== selectedLanguageCode) {
      setSelectedLanguageCode(normalizedLanguage);
      return;
    }

    localStorage.setItem("preferredLanguage", normalizedLanguage);
    sessionStorage.setItem("selectedLang", normalizedLanguage);
  }, [selectedLanguageCode]);

  useEffect(() => {
    const enableAudio = () => {
      if (audioRef1.current) {
        audioRef1.current.muted = false;
        audioRef1.current
          .play()
          .then(() => {
            setShowAudioButton(false);
            setIsAudioPlaying(true);
          })
          .catch(() => setShowAudioButton(true));
      }
      document.removeEventListener("click", enableAudio);
      document.removeEventListener("keydown", enableAudio);
      document.removeEventListener("touchstart", enableAudio);
    };
    document.addEventListener("click", enableAudio);
    document.addEventListener("keydown", enableAudio);
    document.addEventListener("touchstart", enableAudio);
    return () => {
      document.removeEventListener("click", enableAudio);
      document.removeEventListener("keydown", enableAudio);
      document.removeEventListener("touchstart", enableAudio);
    };
  }, []);

  useEffect(() => {
    if (isMicButtonClicked && audioRef1.current) {
      audioRef1.current.pause();
      audioRef1.current.currentTime = 0;
      setIsAudioPlaying(false);
    }
  }, [isMicButtonClicked]);

  useEffect(() => {
    const audio = audioRef1.current;
    if (!audio) return;
    const handleEnd = () => setIsAudioPlaying(false);
    const handlePause = () => setIsAudioPlaying(false);
    audio.addEventListener("ended", handleEnd);
    audio.addEventListener("pause", handlePause);
    return () => {
      audio.removeEventListener("ended", handleEnd);
      audio.removeEventListener("pause", handlePause);
    };
  }, []);

  useEffect(() => {
    if (chatbotOutput.length || chatbotInput.length) {
      const frameId = requestAnimationFrame(() => {
        chatEndRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      });

      return () => cancelAnimationFrame(frameId);
    }
    return undefined;
  }, [chatbotOutput.length, chatbotInput.length, loading]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.load();
    }
  }, [isChecked]);

  useEffect(() => {
    return () => window.speechSynthesis.cancel();
  }, []);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape" && canStop) handleStop();
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [canStop, abortController]);

  useEffect(() => {
    if (searchText.length > 0 && isSuggestionClicked) {
      handleSearch();
      setIsSuggestionClicked(false);
      setTimeout(() => setPreventKeySearch(false), 500);
    }
  }, [searchText, isSuggestionClicked]);

  useEffect(() => {
    const audioToText = async () => {
      if (!audioBase64) return;   // guard: skip empty base64
      setIsSpeechToTextLoading(true);
      try {
        let b64Str = audioBase64;
        // Always use the current selectedLanguageCode and guarantee a non-undefined fallback.
        // Without the fallback, JSON.stringify silently drops undefined → missing field → 422.
        let lang = selectedLanguageCode || "en";
        if (typeof audioBase64 === "object") {
          console.warn("audioBase64 is an object!", audioBase64);
          b64Str = audioBase64.audioBase64 || "";
          lang = audioBase64.source_language || selectedLanguageCode || "en";
        }
        
        if (!b64Str) return;

        // Detect the recording's language before choosing the ASR source language.
        try {
          const detection = await axios.post(BHASHINI_ENDPOINT_URL, {
            pipelineTasks: [{
              taskType: "audio-lang-detection",
              config: {
                serviceId: ALD_SERVICE_ID,
                preprocessors: ["audio_enhancement"],
                language: { targetLanguage: "auto" },
              },
            }],
            inputData: {
              audio: [{ audioContent: b64Str, audioFormat: "wav", samplingRate: 16000, channels: 1 }],
            },
          }, {
            headers: { Authorization: apiKey, "Content-Type": "application/json" },
            timeout: 15000,
          });
          const prediction = detection.data?.pipelineResponse?.[0]?.output?.[0]?.langPrediction?.[0];
          if (prediction && (prediction.langScore == null || prediction.langScore >= 0.6)) {
            lang = syncSpokenLanguage(prediction.langCode) || lang;
          }
        } catch (detectionError) {
          console.warn("Audio language detection failed; using selected language:", detectionError.message);
        }

        console.log("Sending speech2text with payload size:", b64Str.length, "lang:", lang);
        const res = await axios.post(
          SPEECH_TO_TEXT_URL,
          { audioBase64: b64Str, source_language: lang },
          { headers: { "Content-Type": "application/json" } },
        );
        const transcribedText = res.data?.regional_text || "";
        // Use the detected language returned by the backend (auto-detected from audio)
        const spokenLang = res.data?.source_language || lang;
        if (transcribedText) {
          // Update language code so the chatbot request uses the actual spoken language
          syncSpokenLanguage(spokenLang);
          // Mark that this search was triggered by voice so we request audio output
          isVoiceInputRef.current = true;
          setSearchText(transcribedText);
        } else {
          setSearchText("");
        }
      } catch (err) {
        console.log("audio error", err);
        setSearchText("");
      } finally {
        setIsSpeechToTextLoading(false);
        setAudioBase64("");
      }
    };
    if (audioBase64) audioToText();
    // Language changes during ALD must not submit the same recording again.
    // The selected language is captured when a new recording arrives.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioBase64, syncSpokenLanguage]);

  // ── Handlers ──────────────────────────────────────────────────────────────

  const handleInputFocus = useCallback(() => {
    inputRef.current = true;
    setShowLanguages(false);
  }, []);

  const handleToggle = () => setIsChecked((prev) => !prev);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && event.shiftKey) {
      return;
    }
    if (
      event.key === "Enter" &&
      searchText.trim() !== "" &&
      !loading &&
      !preventKeySearch
    ) {
      event.preventDefault();
      handleSearch();
    }
  };

  const handleCopy = (text) => {
    setCopyBar(true);
    navigator.clipboard?.writeText(text);
    setTimeout(() => setCopyBar(false), 500);
  };

  const handleLanuageClick = (code) => {
    syncSpokenLanguage(code);
  };

  const handleLanguageChange = (code) => {
    setSelectedLanguageCode(code);
    i18n.changeLanguage(code);
    setClearSuggestions((previous) => !previous);
  };

  const handleSearch = async (overrideText, overrideLang) => {
    const effectiveText = typeof overrideText === "string" ? overrideText : searchText;
    if (loading || !effectiveText.trim()) return;

    // Capture and immediately reset the voice-input flag so subsequent text queries
    // are not accidentally treated as voice.
    const isVoiceQuery = isVoiceInputRef.current;
    isVoiceInputRef.current = false;

    onQuestionAsked?.();
    setClearSuggestions((prev) => !prev);
    setMicButtonDisabled(true);
    stopListening();
    micRef.current?.stopStreaming();

    const currentTimestamp = generateTimestamp();
    const currentInsightsText = t("insightsMSG");
    const controller = new AbortController();
    setAbortController(controller);
    setCanStop(true);

    let arr = [...chatbotInput];
    arr.push(effectiveText || arr[arr.length - 1]);
    setChatbotInput(arr);
    setSearchText("");
    finalTextRef.current = "";
    interimTextRef.current = "";
    setLoading(true);
    setCorrectedInput("");
    setQuestionLoading(true);
    let timestampArr = [...chatTimestamps];
    timestampArr.push(currentTimestamp);
    setChatTimestamps(timestampArr);
    setPreventKeySearch(true);

    const responseIndex = arr.length - 1;
    latestResponseIndexRef.current = responseIndex;

    // ── Voice path: call non-streaming endpoint and request audio output ──
    if (isVoiceQuery) {
      // Use the auto-detected spoken language if provided, else fall back to UI selection
      const voiceLang = overrideLang || selectedLanguageCode || "en";
      try {
        const payload = {
          input: {
            session_id: sessionId,
            language: voiceLang,
            text: effectiveText,
            audio: "",
            context: "",
            location: userLocation || "",
            user_name: userName || "",
            voice_journey: true,
          },
          output: { format: "audio" },
        };

        const res = await axios.post(CHATBOT_URL, payload, {
          headers: { "Content-Type": "application/json" },
          signal: controller.signal,
        });

        const outputData = res.data?.output || {};
        const responseText = outputData.text || "";
        const responseAudio = outputData.audio || null;
        const responseLang = outputData.language || selectedLanguageCode || "en";
        const responseSuggestions = res.data?.output?.suggestions || [];

        setChatbotOutput((prev) => {
          const next = [...prev];
          next[responseIndex] = {
            output: { text: responseText, audio: responseAudio, language: responseLang, format: "audio" },
            image: null,
            tableHeading: [],
            insightsLabel: currentInsightsText,
            plotlyData: null,
            plotlyTitle: null,
            ground_data: [],
            follow_up_questions: responseSuggestions,
          };
          return next;
        });

        setDetectedLanguage(responseLang);
        setResponseTimestamps((prev) => [...prev, generateTimestamp()]);
        setLoading(false);
        setQuestionLoading(false);
        setError(false);
        setPreventKeySearch(false);
        setCanStop(false);
        setAbortController(null);
        setMicButtonDisabled(false);
      } catch (err) {
        const wasAborted = err.name === "AbortError" || err.code === "ERR_CANCELED";
        const message = wasAborted
          ? "Request was stopped. Please feel free to ask another question anytime."
          : "Something went wrong. Please try again.";
        setChatbotOutput((prev) => {
          const next = [...prev];
          next[responseIndex] = {
            output: { text: message, audio: null },
            image: null, tableHeading: [], insightsLabel: currentInsightsText,
            plotlyData: null, plotlyTitle: null, ground_data: [],
          };
          return next;
        });
        setResponseTimestamps((prev) => [...prev, generateTimestamp()]);
        setLoading(false);
        setQuestionLoading(false);
        setError(!wasAborted);
        setPreventKeySearch(false);
        setCanStop(false);
        setAbortController(null);
        setMicButtonDisabled(false);
      }
      return; // done with voice path
    }

    // ── Text path: streaming SSE ──
    const upsertStreamingResponse = (text) => {
      setChatbotOutput((prev) => {
        const next = [...prev];
        const existing = next[responseIndex] || {
          output: {
            text: "",
            audio: "",
            language: selectedLanguageCode || "en",
            format: "text",
          },
          image: null,
          tableHeading: [],
          insightsLabel: currentInsightsText,
          plotlyData: null,
          plotlyTitle: null,
          ground_data: [],
        };

        next[responseIndex] = {
          ...existing,
          output: {
            ...(existing.output || {}),
            text,
            language: selectedLanguageCode || existing.output?.language || "en",
            format: "text",
          },
          insights: text,
        };
        return next;
      });
    };

    try {
      // ── TLD: auto-detect language of typed text ──────────────────────────
      const tldLang = await detectTextLanguage(effectiveText);
      const resolvedLanguageCode =
        tldLang ||
        selectedLanguageCode ||
        i18n.resolvedLanguage ||
        sessionStorage.getItem("selectedLang") ||
        localStorage.getItem("preferredLanguage") ||
        "en";

      // Update UI language to match detected language so response renders correctly
      if (tldLang && tldLang !== selectedLanguageCode) {
        setSelectedLanguageCode(tldLang);
        i18n.changeLanguage(tldLang);
        console.log("[TLD] Language updated to:", tldLang);
      }

      const payload = {
        input: {
          session_id: sessionId,
          language: resolvedLanguageCode,
          text: effectiveText || arr[arr.length - 1],
          audio: "",
          context: "",
          location: userLocation || "",
          user_name: userName || "",
          voice_journey: isVoiceJourney,
        },
        output: { format: "text" },
        stream: true,
      };

      const response = await fetch(CALL_AGENT_STREAM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      if (!response.body) {
        throw new Error("Streaming response body is unavailable");
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      let streamedText = "";
      let responseAdded = false;

      const ensureResponseSlot = () => {
        if (responseAdded) return;
        setChatbotOutput((prev) => {
          const next = [...prev];
          next[responseIndex] = {
            output: {
              text: "",
              audio: "",
              language: selectedLanguageCode || "en",
              format: "text",
            },
            image: null,
            tableHeading: [],
            insightsLabel: currentInsightsText,
            plotlyData: null,
            plotlyTitle: null,
            ground_data: [],
          };
          return next;
        });
        responseAdded = true;
      };

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split("\n");
        buffer = events.pop() || "";

        for (const rawLine of events) {
          const line = rawLine.trim();
          if (!line.startsWith("data:")) continue;

          const payloadText = line.slice(5).trim();
          if (!payloadText || payloadText === "[DONE]") continue;

          let event;
          try {
            event = JSON.parse(payloadText);
          } catch {
            continue;
          }

      if (event.type === "token") {
            ensureResponseSlot();
            streamedText += event.text || "";
            upsertStreamingResponse(streamedText);
            continue;
          }

          if (event.type === "replace_text") {
            // Backend stripped the follow-up block; replace accumulated text cleanly
            streamedText = event.text || "";
            upsertStreamingResponse(streamedText);
            continue;
          }

          if (event.type === "follow_up" || event.type === "suggestions") {
            // Store follow-up questions or suggestions on the response slot
            const questions = Array.isArray(event.questions) ? event.questions : (Array.isArray(event.suggestions) ? event.suggestions : []);
            setChatbotOutput((prev) => {
              const next = [...prev];
              if (next[responseIndex]) {
                next[responseIndex] = { ...next[responseIndex], follow_up_questions: questions };
              }
              return next;
            });
            continue;
          }

          if (event.type === "error") {
            throw new Error(event.message || "Streaming failed");
          }
        }
      }

      ensureResponseSlot();
      setDetectedLanguage(selectedLanguageCode || "en");
      setResponseTimestamps((prev) => [...prev, generateTimestamp()]);
      setLoading(false);
      setQuestionLoading(false);
      setError(false);
      setPreventKeySearch(false);
      setCanStop(false);
       setAbortController(null);
      setMicButtonDisabled(false);

      // ── Fetch TTS audio for the streamed text so the audio player always appears ──
      // Run silently in background; any failure is non-fatal.
      if (streamedText) {
        (async () => {
          try {
const ttsRes = await axios.post(TTS_URL, {
              text: streamedText,
              // Prefer the language selected via the Bhashini topbar plugin (kept in sync with i18n),
              // then the chatbot's own language selection, before falling back to Hindi.
              language: i18n.resolvedLanguage || selectedLanguageCode || "hi",
            }, {
              headers: { "Content-Type": "application/json" },
            });
            const ttsAudio = ttsRes.data?.audio || null;
            if (ttsAudio) {
              setChatbotOutput((prev) => {
                const next = [...prev];
                if (next[responseIndex]) {
                  next[responseIndex] = {
                    ...next[responseIndex],
                    output: {
                      ...next[responseIndex].output,
                      audio: ttsAudio,
                    },
                  };
                }
                return next;
              });
            }
          } catch (ttsErr) {
            // TTS is best-effort; don't surface this error to the user
            console.warn("TTS fetch failed (non-fatal):", ttsErr);
          }
        })();
      }
    } 

     catch (err) {
      const wasAborted =
        err.name === "AbortError" || err.code === "ERR_CANCELED";
      // Detect HTTP status codes thrown as Error('HTTP 4xx') from the response.ok check
      const httpStatusMatch = !wasAborted && err.message?.match(/^HTTP (\d+)$/);
      const httpStatus = httpStatusMatch ? parseInt(httpStatusMatch[1], 10) : null;
      let message = wasAborted
        ? "Request was stopped. Please feel free to ask another question anytime."
        : err.code === "ECONNABORTED"
          ? "The request timed out. Please try again."
          : err.code === "ERR_NETWORK"
            ? "Network error. Please check your internet connection."
            : err.code === "ERR_BAD_RESPONSE"
              ? "We are temporarily unable to process your request. Please try again in a few minutes."
              : httpStatus && httpStatus >= 500
                ? "The server encountered an error. Please try again in a moment."
                : httpStatus && httpStatus >= 400
                  ? "We could not process your request. Please rephrase your question and try again."
                  : err.response
                    ? `Server error ${err.response.status}: ${err.response.statusText}`
                    : "Something went wrong. Please try again.";
      const errorObj = {
        output: { text: message },
        image: null,
        tableHeading: [],
        insightsLabel: currentInsightsText,
        plotlyData: null,
        plotlyTitle: null,
        ground_data: [],
      };
      setChatbotOutput((prev) => {
        const next = [...prev];
        next[responseIndex] = errorObj;
        return next;
      });
      setResponseTimestamps((prev) => [...prev, generateTimestamp()]);
      setLoading(false);
      setQuestionLoading(false);
      setError(true);
      setPreventKeySearch(false);
      setCanStop(false);
      setAbortController(null);
      setMicButtonDisabled(false);
    }
  };

  const handleStop = () => {
    if (abortController && canStop) abortController.abort();
  };

  const startListening = async () => {
    try {
      setSearchText("Recording is in progress...");
      setIsListening(true);
      isListeningRef.current = true;
      setRecordingTimer(0);
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      // Use AudioContext to capture raw PCM samples (produces real WAV, not WebM)
      const audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
      const source = audioContext.createMediaStreamSource(stream);
      const processor = audioContext.createScriptProcessor(4096, 1, 1);
      const pcmChunks = [];

      processor.onaudioprocess = (e) => {
        const channelData = e.inputBuffer.getChannelData(0);
        pcmChunks.push(new Float32Array(channelData));
      };

      source.connect(processor);
      processor.connect(audioContext.destination);

      // Store refs for cleanup in stopListening
      mediaRecorderRef.current = {
        _stream: stream,
        _audioContext: audioContext,
        _source: source,
        _processor: processor,
        _pcmChunks: pcmChunks,
        stop: function () {
          processor.disconnect();
          source.disconnect();
          audioContext.close();
          stream.getTracks().forEach((track) => track.stop());

          // Combine all PCM chunks into a single Float32Array
          const totalLength = pcmChunks.reduce((acc, chunk) => acc + chunk.length, 0);
          const combined = new Float32Array(totalLength);
          let offset = 0;
          for (const chunk of pcmChunks) {
            combined.set(chunk, offset);
            offset += chunk.length;
          }

          // Build WAV file from raw PCM data
          const sampleRate = 16000;
          const numChannels = 1;
          const bitsPerSample = 16;
          const byteRate = sampleRate * numChannels * (bitsPerSample / 8);
          const blockAlign = numChannels * (bitsPerSample / 8);
          const dataLength = combined.length * (bitsPerSample / 8);
          const buffer = new ArrayBuffer(44 + dataLength);
          const view = new DataView(buffer);

          // WAV header
          const writeStr = (off, str) => { for (let i = 0; i < str.length; i++) view.setUint8(off + i, str.charCodeAt(i)); };
          writeStr(0, 'RIFF');
          view.setUint32(4, 36 + dataLength, true);
          writeStr(8, 'WAVE');
          writeStr(12, 'fmt ');
          view.setUint32(16, 16, true);
          view.setUint16(20, 1, true); // PCM
          view.setUint16(22, numChannels, true);
          view.setUint32(24, sampleRate, true);
          view.setUint32(28, byteRate, true);
          view.setUint16(32, blockAlign, true);
          view.setUint16(34, bitsPerSample, true);
          writeStr(36, 'data');
          view.setUint32(40, dataLength, true);

          // Write PCM samples
          for (let i = 0; i < combined.length; i++) {
            let sample = Math.max(-1, Math.min(1, combined[i]));
            const intSample = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
            view.setInt16(44 + i * 2, Math.round(intSample), true);
          }

          const wavBlob = new Blob([buffer], { type: 'audio/wav' });
          const reader = new FileReader();
          reader.onloadend = () => setAudioBase64(reader.result.split(",")[1]);
          reader.readAsDataURL(wavBlob);
        },
      };

      timerIntervalRef.current = setInterval(() => {
        setRecordingTimer((prev) => {
          if (prev + 1 >= 30) {
            stopListening();
            return 30;
          }
          return prev + 1;
        });
      }, 1000);
    } catch (err) {
      console.error("Mic error:", err);
      setIsListening(false);
    }
  };

  const stopListening = () => {
    // Use ref instead of state to avoid stale closure issues
    if (mediaRecorderRef.current) {
      try {
        mediaRecorderRef.current.stop();
      } catch (e) {
        console.warn("stopListening error:", e);
      }
      setIsListening(false);
      isListeningRef.current = false;
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
      mediaRecorderRef.current = null;
      // If searchText is still the placeholder, clear it
      setSearchText((prev) =>
        prev === "Recording is in progress..." ? "" : prev
      );
    }
  };

  const handleManualInput = (text) => {
    if (isProgrammaticUpdateRef.current) return;
    finalTextRef.current = text;
    interimTextRef.current = "";
    setManualInput(text.length > 0);
    setSearchText(text);
    if (playingAudioIndex !== null) {
      const audio = audioRefs.current[playingAudioIndex];
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      setPlayingAudioIndex(null);
    }
    if (audioRef1.current && !audioRef1.current.paused) {
      audioRef1.current.pause();
      audioRef1.current.currentTime = 0;
    }
  };

  const handlePastedText = async (event) => {
    // Copy/paste is the only input path where the whole source text is
    // available at once, so detect it immediately instead of waiting to send.
    const pastedText = event.clipboardData?.getData("text/plain")?.trim();
    if (!pastedText) return;

    const detectedCode = await detectTextLanguage(pastedText);
    if (!detectedCode) return;

    const languageCode = normalizeLanguageCode(detectedCode);
    setSelectedLanguageCode(languageCode);
    setClearSuggestions((previous) => !previous);
    i18n.changeLanguage(languageCode);

    // Keep the site-level Bhashini plugin and the chatbot in the same language.
    window.dispatchEvent(
      new CustomEvent("bhashini-language-select", {
        detail: { languageCode },
      }),
    );
  };

  const handleCurrentText = (text) => {
    if (!text) return;
    interimTextRef.current = text;
    setSearchText(`${finalTextRef.current} ${interimTextRef.current}`.trim());
  };

  const handleCompletedText = (text) => {
    if (!text) return;
    finalTextRef.current = `${finalTextRef.current} ${text}`.trim();
    interimTextRef.current = "";
    setSearchText(finalTextRef.current);
  };

  const handleAudioRecorded = useCallback((base64Audio) => {
    console.log("🎤 Audio recorded callback received, base64 length:", base64Audio?.length);
    if (base64Audio && base64Audio.length > 100) {
      console.log("✅ Setting audio base64 for speech2text processing");
      setAudioBase64(base64Audio);
    } else {
      console.warn("⚠️ Audio data too short, ignoring:", base64Audio?.length);
    }
  }, []);

  const handlemicClicked = (flag) => {
    hasMicBeenClickedRef.current = true;
    setIsMicButtonClicked(flag);
    setPlayingAudioIndex(null);
    setIsTextBoxOpen(false);
    if (flag) setIsVoiceJourney(true);
    Object.values(audioRefs.current).forEach((audio) => {
      if (audio && !audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
    if (audioRef1.current && !audioRef1.current.paused) {
      audioRef1.current.pause();
      audioRef1.current.currentTime = 0;
    }
    if (!flag) handleSearch();
  };

  const handleWaitingStart = async () => {
    if (selectedLanguageCode !== "hi") {
      const requestBody = {
        pipelineTasks: [
          {
            taskType: "tts",
            config: {
              language: { sourceLanguage: selectedLanguageCode || "en" },
              serviceId: "Bhashini/IITM/TTS",
              audioFormat: "wav",
              samplingRate: 16000,
              gender: "female",
            },
          },
        ],
        inputData: { input: [{ source: t("titleMsg") }] },
      };
      try {
        const response = await axios({
          method: "POST",
          url: BHASHINI_ENDPOINT_URL,
          headers: {
            Authorization: apiKey,
            "Content-Type": "application/json",
          },
          data: requestBody,
          timeout: 30000,
        });
        setWaitingAudio(
          `data:audio/wav;base64,${response.data.pipelineResponse[0].audio[0].audioContent}`,
        );
      } catch (err) {
        console.error("TTS error:", err);
      }
    } else {
      setWaitingAudio(hindiwaiting);
    }
  };

  const handleNewChat = () => {
    onResetNav?.();
    generateNewSession();
    setChatbotInput([]);
    setChatbotOutput([]);
    setChatTimestamps([]);
    setResponseTimestamps([]);
    setLoading(false);
    setError(false);
    setSearchText("");
    finalTextRef.current = "";
    interimTextRef.current = "";
  };

  // Put a suggested reply in the input so the user can edit it before sending.
  const handleFollowUpClick = (question) => {
    if (loading) return;
    finalTextRef.current = question;
    interimTextRef.current = "";
    setSearchText(question);

    setTimeout(() => {
      const inputElement = document.getElementById("react-transliterate-input");
      inputElement?.focus?.();
      inputElement?.setSelectionRange?.(question.length, question.length);
    }, 0);
  };

  const handleEditQuestion = (question) => {
    if (loading) return;

    const editableQuestion = typeof question === "string" ? question : "";
    if (!editableQuestion.trim()) return;

    setIsSuggestionClicked(false);
    setPreventKeySearch(false);
    setIsTextBoxOpen(true);
    handleManualInput(editableQuestion);

    setTimeout(() => {
      if (typeof document === "undefined") return;

      const inputRoot = document.getElementById("react-transliterate-input");
      const inputElement = inputRoot?.matches?.("input, textarea")
        ? inputRoot
        : inputRoot?.querySelector?.("input, textarea");

      inputElement?.focus?.();
      inputElement?.setSelectionRange?.(
        editableQuestion.length,
        editableQuestion.length,
      );
    }, 0);
  };

  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <ChatContainer
      expanded={expanded}
      $embeddedExpanded={embeddedExpanded}
      $showFaq={expanded && chatbotInput?.length === 0}
    >
      {expanded && chatbotInput?.length === 0 && (
        <ExpandedFaq>
          <FAQSection
            faqItems={FAQ_ITEMS}
            onQuestionClick={(question) => {
              setSearchText(question);
              setIsSuggestionClicked(true);
            }}
            title="Frequently Asked Questions (FAQs)"
          />
        </ExpandedFaq>
      )}

      <BotPanel $expanded={expanded} $hasMessages={chatbotInput?.length > 0}>
        {expanded && (
          <ChatPanelHeader>
            <button
              type="button"
              onClick={onExpandMin}
              aria-label="Restore chat to standard size"
              title="Restore chat to standard size"
            >
              <img src={expandIcon} alt="" aria-hidden="true" />
            </button>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close chat assistant"
              title="Close chat"
            >
              <img src={closeIcon} alt="" aria-hidden="true" />
            </button>
          </ChatPanelHeader>
        )}
        {/* ── Scrollable content area ── */}
        <ContentArea
          $expanded={expanded}
          $hasMessages={chatbotInput?.length > 0}
          role="log"
          aria-live="polite"
          aria-relevant="additions text"
          aria-label="Chat conversation history"
        >
          {chatbotInput?.length === 0 && !expanded && (
            <div className="absolute top-0 left-1/2 -translate-x-1/2">
              <ChatBotAvatarCTA />
            </div>
          )}

          {/* ── Chat messages ── */}
          {chatbotInput?.length > 0 && (
            <ChatMessages
              chatbotInput={chatbotInput}
              chatbotOutput={chatbotOutput}
              chatTimestamps={chatTimestamps}
              responseTimestamps={responseTimestamps}
              loading={loading}
              error={error}
              fontSize={fontSize}
              isChecked={isChecked}
              onToggle={handleToggle}
              playingAudioIndex={playingAudioIndex}
              setPlayingAudioIndex={setPlayingAudioIndex}
              audioRefs={audioRefs}
              questionLoading={questionLoading}
              correctedInput={correctedInput}
              backgroundMusicRef={backgroundMusicRef}
              waitingAudioRef={waitingAudioRef}
              waitingAudio={waitingAudio}
              onWaitingStart={handleWaitingStart}
              setIsSourceDataModelOpen={setIsSourceDataModelOpen}
              generateTimestamp={generateTimestamp}
              handleCopy={handleCopy}
              paragraphRef={paragraphRef}
              onFollowUpClick={handleFollowUpClick}
              onEditQuestion={handleEditQuestion}
            />
          )}

          <ChatEndSpacer ref={chatEndRef} />
        </ContentArea>

        {/* ── Input bar — pinned to bottom, same width as content ── */}
        <InputBar $expanded={expanded} $hasMessages={chatbotInput?.length > 0}>
          <ChatBox $expanded={expanded} $hasMessages={chatbotInput?.length > 0}>
            {/* Tap to Speak — home state only */}
            {chatbotInput?.length === 0 && (
              <TapToSpeak>
                {isListening && (
                  <MicStopTooltip role="status" aria-live="polite">
                    {t("tapAgainToStop")}
                  </MicStopTooltip>
                )}
                <TapToSpeakButton
                  className="tap-to-speak__btn"
                  style={{
                    ...MIC_BUTTON_STYLE,
                    background: isListening ? "#e6f7f7" : "#ffffff",
                    boxShadow: isListening
                      ? "0 0 20px rgba(0, 135, 135, 0.55)"
                      : MIC_BUTTON_STYLE.boxShadow,
                  }}
                  onClick={
                    isListening
                      ? stopListening
                      : () => {
                          handleWaitingStart();
                          startListening();
                        }
                  }
                  disabled={isMicButtonDisabled}
                  title={isListening ? "Stop recording" : "Start voice input"}
                  aria-label={isListening ? "Stop voice recording" : "Start voice input"}
                  aria-pressed={isListening}
                  type="button"
                >
                  <img
                    src={micIcon}
                    alt=""
                    aria-hidden="true"
                    width="30"
                    height="25"
                    style={{
                      filter: isListening
                        ? "invert(34%) sepia(90%) saturate(400%) hue-rotate(140deg)"
                        : "none",
                    }}
                  />
                </TapToSpeakButton>
                <TapLabel>
                  {isListening
                    ? `${t("recording")}… ${recordingTimer}s`
                    : t("tapToSpeak")}
                </TapLabel>
                {!isListening && (
                  <TapSubLabel>{t("pressMicForAudio")}</TapSubLabel>
                )}

                {/* OR divider */}
                <Divider aria-hidden="true">
                  <DividerLine />
                  <DividerText>{t("or")}</DividerText>
                  <DividerLine />
                </Divider>
              </TapToSpeak>
            )}

            {/* Text input row */}
            <TextInputRow>
              {/* + New Chat — chat state only */}
              {chatbotInput?.length > 0 && (
                <button
                  className="new-chat-button"
                  onClick={handleNewChat}
                  title="Start a new conversation"
                  aria-label="Start a new conversation"
                  type="button"
                >
                  <img src={refreshButton} alt="" aria-hidden="true" width="50" height="50" />
                </button>
              )}

              {/* Language button */}
              <div ref={languageRef} className="chat-language-control">
                <button
                  type="button"
                  onClick={() => setShowLanguages((prev) => !prev)}
                  title="Change language"
                  aria-label="Change language"
                  aria-haspopup="dialog"
                  aria-expanded={showLanguages}
                >
                  <img src={languageLogo} alt="" aria-hidden="true" />
                </button>

                <LanguageModal
                  isOpen={showLanguages}
                  expanded={expanded}
                  anchorRef={languageRef}
                  selectedLanguageCode={selectedLanguageCode}
                  onClose={() => setShowLanguages(false)}
                  onLanguageChange={handleLanguageChange}
                />
              </div>

              {/* Transliterate input */}
              <div className="chat-text-field relative flex-1 min-w-0">
                <label htmlFor="react-transliterate-input" className="sr-only">
                  {t("searchPlaceholder") || "Ask a question"}
                </label>
                <KpmgTransliterate
                  renderComponent={({ ref: innerRef, ...inputProps }) => (
                    <textarea
                      {...inputProps}
                      ref={innerRef}
                      rows={1}
                      aria-label={t("searchPlaceholder") || "Ask a question"}
                      style={{
                        ...inputProps.style,
                        whiteSpace: "pre-wrap",
                      }}
                    />
                  )}
                  value={searchText}
                  onChangeText={handleManualInput}
                  lang={selectedLanguageCode || "hi"}
                  clearOptionsSignal={clearSuggestions}
                  id="react-transliterate-input"
                  onFocus={handleInputFocus}
                  onPaste={handlePastedText}
                  placeholder={
                    isSpeechToTextLoading
                      ? "Converting speech to text..."
                      : t("searchPlaceholder")
                  }
                  onKeyDown={handleKeyDown}
                  className={`w-full bg-white resize-none overflow-x-hidden overflow-y-auto border border-gray-300 outline-none text-sm shadow-sm focus:border-[var(--bg-color)] focus:ring-1 focus:ring-[var(--bg-color)] transition ${
                    expanded && chatbotInput?.length === 0
                      ? "rounded-lg"
                      : "rounded-full"
                  }`}
                  autoComplete="off"
                  disabled={loading || isSpeechToTextLoading}
                />
              </div>

              {/* Input-row mic is only needed after a chat has started. */}
              {chatbotInput?.length > 0 && (
                <InputMicControl>
                  {isListening && (
                    <MicStopTooltip role="status" aria-live="polite">
                      {t("tapAgainToStop")}
                    </MicStopTooltip>
                  )}
                  <button
                    className="icon-button mic-button"
                    style={{
                      ...MIC_BUTTON_STYLE,
                      width: "48px",
                      height: "48px",
                      background: isListening ? "#e6f7f7" : "#ffffff",
                      boxShadow: isListening
                        ? "0 0 14px rgba(0, 135, 135, 0.55)"
                        : MIC_BUTTON_STYLE.boxShadow,
                    }}
                    onClick={
                      isListening
                        ? stopListening
                        : () => {
                            handleWaitingStart();
                            startListening();
                          }
                    }
                    disabled={isMicButtonDisabled}
                    title={isListening ? `Stop recording (${recordingTimer}s)` : "Voice input"}
                    aria-label={isListening ? "Stop voice recording" : "Start voice input"}
                    aria-pressed={isListening}
                    type="button"
                  >
                    <img
                      src={micIcon}
                      alt=""
                      aria-hidden="true"
                      width="25"
                      height="25"
                      style={{
                        filter: isListening
                          ? "invert(34%) sepia(90%) saturate(400%) hue-rotate(140deg)"
                          : "none",
                      }}
                    />
                  </button>
                </InputMicControl>
              )}

              {/* Send / Stop button */}
              <button
                type="button"
                className={`w-[48px] h-[48px] rounded-full flex items-center justify-center flex-shrink-0 text-white shadow-md transition-all duration-200 ${
                  loading || isSpeechToTextLoading
                    ? "bg-[#005856]"
                    : isListening || !searchText
                      ? "bg-[#005856] opacity-60"
                      : "bg-[#005856] hover:opacity-90"
                }`}
                onClick={loading ? handleStop : handleSearch}
                disabled={
                  isListening ||
                  isSpeechToTextLoading ||
                  (!loading && !searchText)
                }
                title={
                  loading
                    ? "Stop (ESC)"
                    : isListening
                      ? t("tapAgainToStop")
                      : isSpeechToTextLoading
                      ? "Converting speech to text"
                      : "Send (Enter)"
                }
                aria-label={
                  loading
                    ? "Stop response generation"
                    : isListening
                    ? "Stop voice recording"
                    : isSpeechToTextLoading
                    ? "Converting speech to text"
                    : "Send message"
                }
                aria-busy={loading || isSpeechToTextLoading}
              >
                {loading || isSpeechToTextLoading ? (
                  <div className="relative flex items-center justify-center">
                    <div className="absolute w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    <StopIcon style={{ fontSize: 16 }} className="z-10" aria-hidden="true" />
                  </div>
                ) : (
                  <SendIcon style={{ fontSize: 18 }} aria-hidden="true" />
                )}
              </button>
            </TextInputRow>
          </ChatBox>
        </InputBar>

        {/* Hidden SocketMicStreamer */}
        <div className="hidden">
          <SocketMicStreamer
            isUserInputBar={false}
            currentText={handleCurrentText}
            completedText={handleCompletedText}
            language={handleLanuageClick}
            micClicked={handlemicClicked}
            isMicButtonDisabled={isMicButtonDisabled}
            onAudioRecorded={handleAudioRecorded}
            ref={micRef}
          />
        </div>
      </BotPanel>
    </ChatContainer>
  );
};

// const ChatContainer = styled.div`
//   position: relative;
//   overflow: hidden;
//   width: 100%;
//   height: 100%;

//   ${({ expanded }) =>
//     expanded &&
//     `
//       position: fixed;
//       inset: 0;
//       z-index: 999;
//     `}
// `;

const ChatContainer = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  height: 100%;
  padding: ${({ $showFaq }) => ($showFaq ? "20px 28px" : "20px")};
  display: flex;
  flex-direction: column;
  gap: ${({ $showFaq }) => ($showFaq ? "24px" : "0")};
  min-width: 0;
  min-height: 0;

  ${({ expanded, $embeddedExpanded }) =>
    expanded &&
    !$embeddedExpanded &&
    `
      position: fixed;
      inset: 0;
      z-index: ${CHATBOT_OVERLAY_Z_INDEX};
      width: 100vw;
      height: 100vh;
      height: 100dvh;
    `}

  @media (max-width: 640px), (max-height: 800px) {
    padding: ${({ $showFaq }) => ($showFaq ? "10px 12px" : "10px")};
    gap: ${({ $showFaq }) => ($showFaq ? "10px" : "0")};
  }
`;

const ExpandedFaq = styled.div`
  flex-shrink: 0;
  min-width: 0;

  .faq-section {
    padding: 12px 0 6px;
  }

  .faq-title {
    margin-bottom: 10px;
    color: #0b2f5f;
    font-size: 1.35rem;
    line-height: 26px;
    letter-spacing: 0;
  }

  .faq-scroll {
    grid-template-columns: repeat(auto-fit, minmax(min(190px, 100%), 1fr));
    gap: clamp(10px, 1.6vw, 24px) !important;
  }

  .faqlink {
    height: auto !important;
    min-height: 96px;
    font-size: 0.9rem;
  }

  @media (max-width: 1200px) {
    .faq-scroll {
      gap: 12px !important;
    }
  }

  @media (max-width: 900px) {
    .faq-section {
      padding: 2px 0;
    }

    .faq-title {
      margin-bottom: 6px;
      font-size: 1rem;
      line-height: 1.3;
    }

    .faq-scroll {
      grid-template-columns: repeat(
        auto-fit,
        minmax(min(150px, 100%), 1fr)
      ) !important;
      gap: 8px !important;
      overflow: visible;
      padding: 2px;
    }

    .faqlink {
      height: auto !important;
      min-height: 92px;
      font-size: 0.78rem;
    }
  }

  @media (max-width: 560px) {
    .faq-scroll {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .faqlink {
      min-height: 96px;
      font-size: 0.75rem;
    }
  }

  @media (max-width: 380px) {
    .faq-scroll {
      grid-template-columns: 1fr !important;
    }
  }

  @media (max-height: 680px) {
    .faq-section {
      padding: 2px 0;
    }

    .faq-title {
      margin-bottom: 5px;
      font-size: 0.95rem;
      line-height: 1.2;
    }

    .faq-scroll {
      grid-template-columns: none !important;
      grid-auto-flow: column;
      grid-auto-columns: minmax(170px, 32vw);
      gap: 8px !important;
      overflow-x: auto;
      overscroll-behavior-inline: contain;
      padding: 2px 2px 6px;
      scroll-snap-type: inline proximity;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .faqlink {
      min-height: 82px;
      scroll-snap-align: start;
    }
  }
`;

const AssistantHero = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
  left: -130px;
`;

// const BotPanel = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   height: 100%;
//   overflow: hidden;
// `;

const BotPanel = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;

  display: flex;
  flex-direction: column;

  overflow: hidden;
  min-width: 0;

  ${({ $expanded }) =>
    $expanded &&
    `
      border: 2px solid #5fa8d8;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.18);
      box-shadow: 0 8px 24px rgba(0, 88, 86, 0.12);
    `}
`;

const ChatPanelHeader = styled(ChatbotHeader)`
  height: 80px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.50);
  border-bottom: 1px solid #e5e7eb;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 2px solid #008787;
    outline-offset: 3px;
    border-radius: 8px;
  }

  img {
    display: block;
  }

  @media (max-width: 640px), (max-height: 800px) {
    height: 54px;
  }
`;

// const ContentArea = styled.div`
//   flex: 1;
//   overflow-y: auto;
//   display: flex;
//   flex-direction: column;
//   min-height: 0;
//   position: relative;
// `;

const ContentArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-bottom: ${({ $expanded, $hasMessages }) =>
    $expanded && $hasMessages ? "126px" : "0"};
  padding: ${({ $expanded, $hasMessages }) =>
    $expanded && $hasMessages ? "14px 18px 10px" : "0"};

  position: relative;
  min-width: 0;

  @media (max-width: 640px) {
    margin-bottom: 0;
    padding: ${({ $expanded, $hasMessages }) =>
      $expanded && $hasMessages ? "10px 8px 8px" : "0"};
  }
`;

const ChatEndSpacer = styled.div`
  height: 1px;
  flex-shrink: 0;
`;

// const InputBar = styled.div`
//   flex-shrink: 0;
//   padding-top: 10px;
// `;

const InputBar = styled.div`
  flex-shrink: 0;
  padding: ${({ $expanded, $hasMessages }) =>
    $expanded
      ? $hasMessages
        ? "0 12px 12px"
        : "0 28px 28px"
      : "0"};
  min-width: 0;

  ${({ $expanded }) =>
    $expanded &&
    `
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 5;
    `}

  @media (max-width: 640px), (max-height: 800px) {
    padding: ${({ $expanded, $hasMessages }) =>
      $expanded ? ($hasMessages ? "0 8px 8px" : "0 8px 10px") : "0"};
  }

  @media (max-width: 640px) {
    position: relative;
    max-height: 100%;
    overflow-y: auto;
  }
`;

const TextInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;

  .chat-text-field textarea {
    display: block;
    box-sizing: border-box;
    width: 100%;
    /* Viewport-relative height works even when the parent has auto height. */
    height: clamp(3.5em, 8vh, 4em);
    height: clamp(3.5em, 8dvh, 4em);
    padding: 0.25em clamp(0.5rem, 2%, 0.75rem);
    line-height: 1.4;
  }

  .chat-language-control {
    position: relative;
    top: 0.5rem;
  }

  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: repeat(3, 48px) minmax(48px, 1fr);
    gap: 6px;

    > * {
      grid-row: 2;
      min-width: 0;
    }

    > .chat-text-field {
      grid-row: 1;
      grid-column: 1 / -1;
    }

    textarea {
      display: block;
      border-radius: 14px;
      font-size: 1rem;
      overflow-wrap: anywhere;
    }

    > div > button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
    }

    > div > button > img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    > button:last-child {
      grid-column: 4;
      justify-self: end;
    }
  }
`;
const ChatBox = styled.div`
  border: ${({ $expanded }) =>
    $expanded ? "0" : "2px solid #689cbe"};
  border-radius: ${({ $expanded }) => ($expanded ? "0" : "20px")};
  background: ${({ $expanded }) =>
    $expanded ? "transparent" : "rgba(255, 255, 255, 0.92)"};
  backdrop-filter: ${({ $expanded }) =>
    $expanded ? "none" : "blur(10px)"};
  box-shadow: ${({ $expanded }) =>
    $expanded ? "none" : "0 4px 24px rgba(0, 88, 86, 0.1)"};

  padding: ${({ $expanded, $hasMessages }) =>
    $expanded ? ($hasMessages ? "10px 0 0" : "0") : "4px 8px"};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ $expanded, $hasMessages }) =>
    $expanded && !$hasMessages ? "18px" : "6px"};
  width: 100%;
  min-width: 0;

  > div:last-child {
    min-width: 0;
  }

  @media (max-width: 480px), (max-height: 800px) {
    gap: 5px;
  }
`;

const TapToSpeak = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  width: 100%;
  padding-bottom: 2px;
`;

const TapToSpeakButton = styled.button`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid #005856;
  background: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 2px 8px rgba(0, 88, 86, 0.15);
  transition: transform 0.15s ease;

  &:hover:not(:disabled) {
    transform: scale(1.06);
  }

  @media (max-height: 800px) {
    width: 44px;
    height: 44px;
  }
`;

const MicStopTooltip = styled.span`
  position: relative;
  max-width: min(280px, calc(100vw - 48px));
  padding: 11px 12px;
  border-radius: 8px;
  background: #005856;
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.45;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 88, 86, 0.28);
  animation: mic-stop-tooltip-blink 1s ease-in-out infinite;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    width: 12px;
    height: 12px;
    background: #005856;
    transform: translateX(-50%) rotate(45deg);
  }

  @keyframes mic-stop-tooltip-blink {
    0%,
    100% {
      opacity: 1;
      transform: translateY(0);
    }
    50% {
      opacity: 0.45;
      transform: translateY(-3px);
    }
  }
`;

const InputMicControl = styled.div`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;

  ${MicStopTooltip} {
    position: absolute;
    right: 0;
    bottom: calc(100% + 10px);
    width: max-content;
    max-width: min(280px, calc(100vw - 32px));
    z-index: 2;

    &::after {
      left: auto;
      right: 18px;
      transform: rotate(45deg);
    }
  }
`;

const TapLabel = styled.span`
  font-weight: 700;
  color: #103058;
  font-size: 1.15rem;

  @media (max-width: 480px), (max-height: 800px) {
    font-size: 0.95rem;
  }
`;

const TapSubLabel = styled.span`
    font-weight: 600;
  color: #103058;
  font-size: 1.05rem;
  text-align: center;

  @media (max-width: 480px), (max-height: 800px) {
    font-size: 0.8rem;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: #e5e7eb;
`;

const DividerText = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  color: #9ca3af;
`;

const CircularButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const NewChatButton = styled(CircularButton)`
  background: #008787;
  color: white;
  border: 2px solid #008787;

  &:hover:not(:disabled) {
    border-color: #009999;
  }
`;

const SendButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;
  color: white;

  background: #005856;

  opacity: ${({ disabled, loading }) => (disabled && !loading ? 0.6 : 1)};

  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

// ── Name Prompt Styled Components ───────────────────────────────────

const NamePromptOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 88, 86, 0.55);
  backdrop-filter: blur(4px);
  border-radius: inherit;
`;

const NamePromptCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 32px 28px;
  width: 90%;
  max-width: 360px;
  box-shadow: 0 16px 48px rgba(0, 88, 86, 0.25);
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to   { transform: translateY(0);   opacity: 1; }
  }
`;

const NamePromptTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  color: #005856;
  margin: 0;
  text-align: center;
`;

const NamePromptSubtitle = styled.p`
  font-size: 0.83rem;
  color: #555;
  margin: 0;
  text-align: center;
  line-height: 1.5;
`;

const NamePromptInput = styled.input`
  width: 100%;
  padding: 10px 16px;
  border: 2px solid #cde8e7;
  border-radius: 999px;
  font-size: 0.9rem;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;

  &:focus {
    border-color: #005856;
  }
`;

const NamePromptButton = styled.button`
  width: 100%;
  margin-top: 4px;
  padding: 11px 0;
  background: #005856;
  color: white;
  border: none;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) { opacity: 0.88; }
  &:disabled { opacity: 0.45; cursor: not-allowed; }
`;

export default PrayasBot;
